var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 0.333336C0.996528 0.333336 0 1.32986 0 2.55556V11.4444C0 12.6701 0.996528 13.6667 2.22222 13.6667H17.7778C19.0035 13.6667 20 12.6701 20 11.4444V2.55556C20 1.32986 19.0035 0.333336 17.7778 0.333336H2.22222ZM4.44444 11.4444H2.22222V9.22222C3.44792 9.22222 4.44444 10.2188 4.44444 11.4444ZM2.22222 4.77778V2.55556H4.44444C4.44444 3.78125 3.44792 4.77778 2.22222 4.77778ZM15.5556 11.4444C15.5556 10.2188 16.5521 9.22222 17.7778 9.22222V11.4444H15.5556ZM17.7778 4.77778C16.5521 4.77778 15.5556 3.78125 15.5556 2.55556H17.7778V4.77778ZM10 3.66667C10.8841 3.66667 11.7319 4.01786 12.357 4.64298C12.9821 5.2681 13.3333 6.11595 13.3333 7C13.3333 7.88406 12.9821 8.7319 12.357 9.35703C11.7319 9.98215 10.8841 10.3333 10 10.3333C9.11595 10.3333 8.2681 9.98215 7.64298 9.35703C7.01786 8.7319 6.66667 7.88406 6.66667 7C6.66667 6.11595 7.01786 5.2681 7.64298 4.64298C8.2681 4.01786 9.11595 3.66667 10 3.66667Z",
    fill: "#7DCFB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.0def74b3acd5cd0db5f7547a997cccb4.svg";
export { ForwardRef as ReactComponent };